import axios from 'axios';

export default {
  putObject(url, file, config) {
    return axios.put(url, file, config).then(response => response);
  }
};
